import type { ComponentProps } from "react";

import { Flex } from "components/core/Flex";
import type { FlexProps } from "components/core/Flex";
import { cn } from "helpers/cn";

// Translucent so it composites over tinted surfaces (month-calendar today/frost
// cells); 10% is the pulse-adjusted match for antd's 6% → 15% shimmer.
const Skeleton = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={cn("animate-pulse rounded-md bg-black/10", className)}
    data-slot="skeleton"
    {...props}
  />
);

type SkeletonTextProps = Omit<FlexProps, "children"> & {
  lines?: number;
  titleWidth?: number | string;
  lineWidths?: (number | string)[];
};

const SkeletonText = ({
  lineWidths = [],
  lines = lineWidths.length || 3,
  titleWidth = "38%",
  ...props
}: SkeletonTextProps) => {
  const rows = Array.from({ length: lines }, (_, index) => ({
    id: `line-${index}`,
    width: lineWidths[index] ?? (index === lines - 1 ? "61%" : "100%")
  }));

  return (
    <Flex data-slot="skeleton-text" direction="col" gap={4} {...props}>
      <Skeleton className="mb-2 h-4" style={{ width: titleWidth }} />
      {rows.map(({ id, width }) => (
        <Skeleton key={id} className="h-4" style={{ width }} />
      ))}
    </Flex>
  );
};

export { SkeletonText };
export default Skeleton;
